import { render, staticRenderFns } from "./GlobalCategorySettingDialog.vue?vue&type=template&id=3ac346ef&scoped=true"
import script from "./GlobalCategorySettingDialog.vue?vue&type=script&lang=js"
export * from "./GlobalCategorySettingDialog.vue?vue&type=script&lang=js"
import style0 from "./GlobalCategorySettingDialog.vue?vue&type=style&index=0&id=3ac346ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac346ef",
  null
  
)

export default component.exports